/**
 * Allow only same-app relative paths for post-auth redirects (open redirect guard).
 */
export function safeNextPath(raw: string | null | undefined, fallback = "/matches"): string {
  const value = (raw ?? "").trim();
  if (!value.startsWith("/")) return fallback;
  if (value.startsWith("//")) return fallback;
  if (value.includes("://")) return fallback;
  return value;
}
